import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import {SiJava} from 'react-icons/si'
import {SiPython} from 'react-icons/si'
import {SiDiagramsdotnet} from 'react-icons/si'
import {SiReact} from 'react-icons/si'
import {SiJavascript} from 'react-icons/si'
import {SiHtml5} from 'react-icons/si'
import {SiCsharp} from 'react-icons/si'
import {GrMysql} from 'react-icons/gr'
import {SiFirebase} from 'react-icons/si'
import {SiMongodb} from 'react-icons/si'
import {FaFlask} from 'react-icons/fa'
import {SiJunit5} from 'react-icons/si'
import {BsViewList} from 'react-icons/bs'
import {SiReactos} from 'react-icons/si'
import {SiAmazonaws} from 'react-icons/si'
import {SiMicrosoftazure} from 'react-icons/si'
import {SiDocker} from 'react-icons/si'
import {SiKeras} from 'react-icons/si'
import {SiNumpy} from 'react-icons/si'
import {SiTerraform} from 'react-icons/si'



const Experience = () => {
  return (
    <section id='skills'>
      <h5>
        What Strength I have
      </h5>
      <h2>My Skills</h2>

      <div className='container experience__container'>
        <div className='experience__frontend'>
          <h3>Languages and Databases</h3>
          <div className='experience__content'>
            <article className='experience__details'>
            <SiJava/>
            <div>
              <h4>Java</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiPython/>
            <div>
              <h4>Python</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiDiagramsdotnet/>

            <div>

              <h4>.NET</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiCsharp/>

            <div>

              <h4>C#</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiReact/>
            <div>
              <h4>React</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiJavascript/>
            <div>
              <h4>Javascript</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiHtml5/>
            <div>
              <h4>HTML</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <GrMysql/>
            <div>
              <h4>MySql</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiMongodb/>
            <div>
              <h4>MongoDb</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiFirebase/>
            <div>
              <h4>Firebase</h4>
              
            </div>
            </article>
          </div>

        </div>







        <div className='experience__backend'>
        <h3>Frameworks and Tools</h3>
          <div className='experience__content'>
            <article className='experience__details'>
            <FaFlask/>
            <div>
              <h4>Flask</h4>
             
            </div>
            </article>

            <article className='experience__details'>
            <SiJunit5/>
            <div>
              <h4>JUnit</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <BsViewList/>
              <div>
              <h4>MVC</h4>
              
              </div>
            </article>

            <article className='experience__details'>
            <SiReactos/>
            <div>
              <h4>React Md</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiTerraform/>
            <div>
              <h4>Sitecore</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiAmazonaws/>
            <div>
              <h4>AWS</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiMicrosoftazure/>
            <div>
              <h4>Azure</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiDocker/>
            <div>
              <h4>Docker</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiKeras/>
            <div>
              <h4>Keras</h4>
              
            </div>
            </article>

            <article className='experience__details'>
            <SiNumpy/>
            <div>
              <h4>Numpy</h4>
              
            </div>
            </article>

            
          </div>

        </div>

      </div>

    </section>
  )
}

export default Experience